import { render } from "./AtomTitle.vue?vue&type=template&id=1c1413fa&scoped=true&ts=true"
import script from "./AtomTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTitle.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTitle.vue?vue&type=style&index=0&id=1c1413fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1413fa"],['__file',"src/components/atoms/AtomTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c1413fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c1413fa', __exports__)) {
    api.reload('1c1413fa', __exports__)
  }
  
  module.hot.accept("./AtomTitle.vue?vue&type=template&id=1c1413fa&scoped=true&ts=true", () => {
    api.rerender('1c1413fa', render)
  })

}


export default __exports__